// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMinElectionAmountTypePropertyDto
 */
export interface IMinElectionAmountTypePropertyDto {
    /**
     * 
     * @type {number}
     * @memberof IMinElectionAmountTypePropertyDto
     */
    min_election_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IMinElectionAmountTypePropertyDto
     */
    min_election_amount_type?: IMinElectionAmountTypePropertyDtoMinElectionAmountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IMinElectionAmountTypePropertyDto
     */
    min_election_amount_type_state?: IMinElectionAmountTypePropertyDtoMinElectionAmountTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IMinElectionAmountTypePropertyDtoMinElectionAmountTypeEnum {
    ZERO = 'ZERO',
    CUSTOM = 'CUSTOM'
}
/**
* @export
* @enum {string}
*/
export enum IMinElectionAmountTypePropertyDtoMinElectionAmountTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IMinElectionAmountTypePropertyDto interface.
 */
export function instanceOfIMinElectionAmountTypePropertyDto(value: object): value is IMinElectionAmountTypePropertyDto {
    return true;
}

export function IMinElectionAmountTypePropertyDtoFromJSON(json: any): IMinElectionAmountTypePropertyDto {
    return IMinElectionAmountTypePropertyDtoFromJSONTyped(json, false);
}

export function IMinElectionAmountTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMinElectionAmountTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'min_election_amount': json['min_election_amount'] == null ? undefined : json['min_election_amount'],
        'min_election_amount_type': json['min_election_amount_type'] == null ? undefined : json['min_election_amount_type'],
        'min_election_amount_type_state': json['min_election_amount_type_state'] == null ? undefined : json['min_election_amount_type_state'],
    };
}

export function IMinElectionAmountTypePropertyDtoToJSON(json: any): IMinElectionAmountTypePropertyDto {
    return IMinElectionAmountTypePropertyDtoToJSONTyped(json, false);
}

export function IMinElectionAmountTypePropertyDtoToJSONTyped(value?: IMinElectionAmountTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min_election_amount': value['min_election_amount'],
        'min_election_amount_type': value['min_election_amount_type'],
        'min_election_amount_type_state': value['min_election_amount_type_state'],
    };
}

